import { Typography } from "antd";
import {
  BASE_COLORS,
  FONT_FAMILY,
  FONT_SIZE_PX,
  FONT_WEIGHT,
} from "config/theme/constants";
import styled from "styled-components";

export const ActivityLogWrapper = styled.div`
  .ant-popover .ant-popover-inner {
    background-color: ${BASE_COLORS.solitude};
    border: 1px solid ${BASE_COLORS.solitude};
    display: none;
  }
  .tableRow {
    overflow: hidden;
    th,
    td {
      white-space: break-spaces !important;
    }
  }
  .tableContainer {
    overflow-x: auto !important;
    width: 100%;
  }

  .tableContainer .ant-table {
    min-width: 1000px; /* Adjust this value based on your table's content */
  }

  .tableContainer th,
  .tableContainer td {
    white-space: nowrap; /* Prevents breaking text into multiple lines */
  }
`;

export const PDFWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;

  .pdf-document {
    margin-top: -3px;
    margin-right: -5px;
    height: 46vh;
    overflow-y: auto !important;
    width: 100%;
    padding: 20px 0px 20px 0px;

    @media screen and (max-width: 1024px) {
      overflow-x: auto;
    }
  }

  .form-container {
    width: 450px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    overflow-y: auto !important;
    height: 70vh;
  }
`;

export const PdfFormTitle = styled(Typography.Text)`
  font-weight: ${FONT_WEIGHT.semibold};
  font-size: ${FONT_SIZE_PX.xl};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ErrorMessage = styled.p`
  font-size: 13px;
  margin-bottom: 20px;
  color: red;
  gap: 5px;
`;

export const PDFFormContainer: any = styled.div`
  border-radius: 5px;
  width: ${(props: any) => (props.from === "INVOICE" ? "100%" : "45%")};
  width: ${(props: any) => (props.from === "INVOICE" ? "100%" : "45%")};
  padding: 0 0 0 15px;
  display: flex;
  flex-direction: column;

  .lineitem {
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-top: -20px;
  }
`;

export const FormContainer = styled.div`
  border-radius: 5px;
  border: 1px solid ${BASE_COLORS.dustyGray};
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 53vh;
  overflow-y: auto !important;

  .lineitem {
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-top: -20px;
  }
`;

export const PDFFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  margin-top: 15px;
`;

export const ActivityWrapper = styled.div`
  .page-title {
    font-size: ${FONT_SIZE_PX.FONT23};
    font-weight: ${FONT_WEIGHT.normal};
    font-family: ${FONT_FAMILY.main};
    color: ${BASE_COLORS.downRiver};
    opacity: 1;
  }
  .my-account-non-editable .ant-form-item .ant-form-item-label {
    padding: 0 !important;
  }
  .settings-card-permission {
    text-align: center;
    box-shadow: inset 0 0 2px ${BASE_COLORS.altolight};
    margin-top: 10px;
    min-height: 80px;
  }
`;

export const LinkWrapper = styled.div`
  color: ${BASE_COLORS.bostonBlue};
  font-family: ${FONT_FAMILY.main};
  display: flex;
  flex-direction: column;
  align-items: start;
  cursor: pointer;
`;

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 5px;
`;
export const TimeFrameWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  display: flex;
  align-items: center;
  flex-direction: row;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column !important;
    align-items: flex-start;
    width: 100%;
  }
`;

export const integratedCashCardStyle = { marginBottom: 4 };

export const integratedCashCardBodyStyle = { padding: "6px 12px" };

export const integratedCashSectionHeadingStyle = {
  display: "block" as const,
  marginBottom: 4,
  fontSize: FONT_SIZE_PX.xs,
  fontFamily: "POPPINS",
};

export const integratedCashRowStyle = { margin: 0 };
